import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
const TOKEN_KEY = "roots_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const photoUrl = (p) =>
  p && p.id
    ? `${API_BASE}/photos/${p.id}/file?auth=${getToken()}${p.updated_at ? `&v=${encodeURIComponent(p.updated_at)}` : ""}`
    : "";

export const originalPhotoUrl = (p) =>
  p && p.id && p.has_original
    ? `${API_BASE}/photos/${p.id}/file?variant=original&auth=${getToken()}${p.updated_at ? `&v=${encodeURIComponent(p.updated_at)}` : ""}`
    : "";

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function apiErr(e, fallback = "Something went wrong. Please try again.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return String(d);
}

export async function downloadFile(path, filename) {  const res = await fetch(`${API_BASE}${path}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  if (!res.ok) throw new Error("Download failed");
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export async function uploadTenderDocument(wizardId, file, onProgress) {
  const token = getToken();
  const base = `${API_BASE}/wizard/${wizardId}/tender/documents`;
  const initRes = await fetch(`${base}/init`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
    body: JSON.stringify({ filename: file.name, content_type: file.type || "application/octet-stream", size: file.size }),
  });
  if (!initRes.ok) throw new Error((await initRes.json().catch(() => ({}))).detail || "Upload could not start");
  const { upload_id } = await initRes.json();
  const CHUNK = 1024 * 1024;
  let index = 0;
  for (let start = 0; start < file.size; start += CHUNK) {
    const buf = await file.slice(start, start + CHUNK).arrayBuffer();
    const res = await fetch(`${base}/${upload_id}/chunk?index=${index}`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/octet-stream" },
      body: buf,
    });
    if (!res.ok) throw new Error("Upload failed mid-transfer");
    index++;
    onProgress?.(Math.min(99, Math.round(((start + CHUNK) / Math.max(file.size, 1)) * 100)));
  }
  const done = await fetch(`${base}/${upload_id}/complete`, {
    method: "POST", headers: { Authorization: `Bearer ${token}` },
  });
  if (!done.ok) throw new Error((await done.json().catch(() => ({}))).detail || "Could not finalize upload");
  onProgress?.(100);
  return done.json();
}

export default api;
